import localization from "../../config/localization";
import {Checkbox, FormControlLabel, FormHelperText, MenuItem, Radio, RadioGroup, Select} from "@material-ui/core";
import {oneToTen} from "../../utils";
import React from "react";

const HomeElementStyleSelection = (props) => {
  return (
    <>
      <span>{localization.get('home_editor.format')}</span>
      <div style={{display: "flex"}}>
        <RadioGroup
          name="shape"
          value={props.shape}
          onChange={props.onChange}
          style={{marginRight: 30, float: "left", position: "relative", flexDirection: "row"}}
        >
          {props.type !== 'featured' && <FormControlLabel value="square" control={<Radio color="default"/>} label={localization.get('shape.square')}/>}
          {props.type !== 'featured' && <FormControlLabel value="round" control={<Radio color="default"/>} label={localization.get('shape.round')}/>}
          {props.type === 'carousel' && <FormControlLabel value="16:9" control={<Radio color="default"/>} label={localization.get('16:9')}/>}
          {props.type === 'carousel' && <FormControlLabel value="rectangle" control={<Radio color="default"/>} label={localization.get('shape.rectangle')}/>}
          {props.type === 'featured' && <FormControlLabel value="x4" control={<Radio color="default"/>} label={localization.get('shape.x4')}/>}
          {props.type === 'featured' && <FormControlLabel value="x2" control={<Radio color="default"/>} label={localization.get('shape.x2')}/>}
          {props.type === 'featured' && <FormControlLabel value="x1" control={<Radio color="default"/>} label={localization.get('shape.x1')}/>}
        </RadioGroup>

        {(props.shape === 'square' && props.type === 'grid') &&
        <FormControlLabel
          control={
            <Checkbox
              style={{color: "#4cc2d5"}}
              checked={props.fixedTitle}
              onChange={() => props.onCheckboxChange('fixedTitle')}
            />
          }
          label={localization.get('home_editor.grid.fixed_title')}
        />
        }
        { props.shape === 'round' && props.type !== 'carousel' &&
        <FormControlLabel
          control={
            <Checkbox
              style={{color: "#4cc2d5"}}
              checked={props.withBackground}
              onChange={() => props.onCheckboxChange('withBackground')}
            />
          }
          label={localization.get('home_editor.grid.background')}
        />
        }
        {(props.shape === '16:9' || props.shape === 'x4') &&
        <FormControlLabel
          control={
            <Checkbox
              style={{color: "#4cc2d5"}}
              checked={props.numbered}
              onChange={() => props.onCheckboxChange('numbered')}
            />
          }
          label={localization.get('home_editor.numbered')}
        />
        }
        {(props.shape === 'rectangle' || (props.shape === 'square' && props.type === 'carousel')) &&
        <FormControlLabel
          control={
            <Checkbox
              style={{color: "#4cc2d5"}}
              checked={props.onlyImage}
              onChange={() => props.onCheckboxChange('onlyImage')}
            />
          }
          label={localization.get('home_editor.only_image')}
        />
        }

      </div>

      {props.type === 'featured' && ['x2', 'x4'].includes(props.shape) &&
        <>
          <span>{localization.get('home_editor.style')}</span>
          <div style={{display: "flex"}}>
            <RadioGroup
              name="featuredType"
              value={props.featuredType}
              onChange={props.onChange}
              style={{marginRight: 30, float: "left", position: "relative", flexDirection: "row", width: "100%"}}
            >
              <FormControlLabel value="default" control={<Radio color="default"/>} label={localization.get('default')}/>
              <FormControlLabel value="inverted" control={<Radio color="default"/>} label={localization.get('home_editor.inverted')}/>
              {props.shape === 'x2' && <FormControlLabel value="editorial" control={<Radio color="default"/>} label={localization.get('home_editor.editorial_up')}/>}
            </RadioGroup>
          </div>
        </>
      }

      {(props.type === 'grid' || (props.type === 'carousel' && props.shape === 'round')) &&
      <div style={{float: "left", position: "relative"}}>
        <div style={{float: "left", position: "relative", width: 80, margin: "15px 0"}}>
          <Select
            value={props.columns}
            name="columns"
            onChange={props.onChange}
          >
            {[4,6].map(i => <MenuItem value={i}>{i}</MenuItem>)}
          </Select>
          <FormHelperText>{localization.get('home_editor.columns')}</FormHelperText>
        </div>
        {props.type === 'grid' &&
        <div style={{float: "left", position: "relative", width: 50, margin: "15px 0"}}>
          <Select
            name="rowsToShow"
            value={props.rowsToShow}
            onChange={props.onChange}
            style={{width: "inherit"}}
          >
            {oneToTen().map(i => <MenuItem value={i}>{i}</MenuItem>)}
          </Select>
          <FormHelperText>{localization.get('home_editor.rows_to_show')}</FormHelperText>
        </div>
        }
      </div>
      }

    </>
  )
}

export default HomeElementStyleSelection
